export default {
  // Product state management
  currentProduct: null,
  currentVariant: null,
  sampledProducts: new Map(), // Track which products have been sampled

  // Initialize product data
  setProduct(product, variant) {
    this.currentProduct = product;
    this.currentVariant = variant;
  },

  // Update variant when user changes selection
  updateVariant(variant) {
    this.currentVariant = variant;
  },

  // Track sampled products
  markProductSampled(productId, variantId) {
    const key = `${productId}-${variantId}`;
    this.sampledProducts.set(key, {
      productId,
      variantId,
      sampledAt: new Date().toISOString()
    });
  },

  // Check if product/variant combo has been sampled
  isProductSampled(productId, variantId) {
    const key = `${productId}-${variantId}`;
    return this.sampledProducts.has(key);
  }
};
